import { createTheme } from "@material-ui/core/styles";
import buildClientColors, { SAFE_CLIENT_COLOR } from "./tokens";

// Re-exportado para compatibilidade com importadores existentes.
export { SAFE_CLIENT_COLOR };

// Monta o tema MUI a partir das cores da implementacao. A derivacao das cores
// vive em ``theme/tokens.js`` (fonte unica). Aqui apenas embrulhamos os tokens
// no formato esperado pelo MUI (palette.primary + palette.custom).
const createCustomTheme = (
  implementationColor = SAFE_CLIENT_COLOR,
  implementationTextColor = undefined,
) => {
  try {
    const custom = buildClientColors({
      color: implementationColor,
      textColor: implementationTextColor,
    });
    return createTheme({
      palette: {
        primary: { main: custom.clientColor },
        custom,
      },
    });
  } catch (error) {
    // Fallback defensivo: nunca deixar a app sem tema por causa de uma cor.
    console.warn("Error creating custom theme, using default:", error);
    const custom = buildClientColors({ color: SAFE_CLIENT_COLOR });
    return createTheme({
      palette: {
        primary: { main: custom.clientColor },
        custom,
      },
    });
  }
};

export default createCustomTheme;
